module.exports = __webpack_public_path__ + "img/French Polynesia.bf158bd3.svg";